var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsageRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 19.9639C18.2422 20.6319 18.6641 21.2646 19.2617 21.5459L34.2061 28.7539C31.2876 33.5008 26.0127 36.666 20.0352 36.666C10.8229 36.6659 3.33398 29.1762 3.33398 19.9639C3.334 11.3141 9.87369 4.24624 18.2422 3.33203V19.9639ZM21.7939 3.33203C30.1974 4.24639 36.7373 11.3142 36.7373 19.9639C36.7373 21.9329 36.3858 23.7966 35.7529 25.5547L21.7939 18.8389V3.33203Z",
    fill: "#DE235C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageRate);
export default __webpack_public_path__ + "static/media/usageRate.8c643865125c6934c53f197b99547d25.svg";
export { ForwardRef as ReactComponent };